function navigateBack(fallbackUrl) {
    try {
        const currentUrl = new URL(document.URL);
        const referrerUrl = new URL(document.referrer);

        if (currentUrl.origin === referrerUrl.origin) {
            window.open(referrerUrl, "_self");
        } else {
            window.open(fallbackUrl, "_self");
        }

        return false;
    } catch {
        return true;
    }

}

new Swiper('.swiper-photos', {
// Optional parameters
// direction: 'vertical',
    loop: false,
    allowTouchMove: true,
    effect: 'fade',
    crossFade: 'true',
    spaceBetween: 0,
    slidesPerView: 1,
    centeredSlides: true,

// If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },

// Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

});

new Swiper('.swiper-videos', {
// Optional parameters
    loop: false,
    allowTouchMove: true,
    effect: 'slide',
    spaceBetween: 0,
    slidesPerView: 1,
    centeredSlides: true,

// If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },

// Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    on: {
        slideChange: function () {
// players[mySwiper.previousIndex].pauseVideo();
// players[mySwiper.activeIndex].playVideo();
        }
    }

});